import { useEffect } from "react";

export const useFavicon = (faviconUrl) => {
	useEffect(() => {
		if (!faviconUrl) return;

		const link = document.querySelector("link[rel~='icon']");

		if (link) {
			link.href = faviconUrl;
		} else {
			const newLink = document.createElement("link");
			newLink.rel = "icon";
			newLink.href = faviconUrl;
			document.head.appendChild(newLink);
		}
	}, [faviconUrl]);

	return null;
};
